<div id="snackbar">
  <div *ngIf="messageType=='string'" class="snackbar-content">
    <div [innerHTML]="message"></div>
    <div class="dismiss" (click)="dismissToast()">DISMISS</div>
  </div>
  <div *ngIf="messageType=='array'">
    <div *ngFor="let tmessage of message; let i=index" class="snackbar-content mt-2">
      <!-- <div [innerHTML]="tmessage"></div> -->
      <div class="message">{{tmessage}}</div>
      <div class="dismiss" (click)="dismissToast()">DISMISS</div>
    </div>
  </div>
</div>
